import type { ReactChildren } from '@fluentui/react-northstar';
import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import { Flex } from '@archipro-design/aria';
import * as S from './ProductContainer.style';

interface ProductContainerProps {
    children: ReactChildren;
}

const ProductContainer = ({ children }: ProductContainerProps) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();

    return (
        <Flex column={mobile} hAlign="center" className={css(S.Container)}>
            <Flex
                column={true}
                vAlign="start"
                className={css(S.ContainerInner)}
            >
                {children}
            </Flex>
        </Flex>
    );
};

export default ProductContainer;
